import { __read } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { registerStickyHeader } from './stickyScrollRegistry';
var StickyHeader = function (props) {
    var showGoBack = props.showGoBack, goBack = props.goBack, title = props.title, onSticky = props.onSticky, onUnSticky = props.onUnSticky;
    var ref = useRef(null);
    var _a = __read(useState(false), 2), isSticky = _a[0], setSticky = _a[1];
    var stickyRef = useRef(false);
    var propsRef = useRef({ title: title, onSticky: onSticky, onUnSticky: onUnSticky });
    propsRef.current = { title: title, onSticky: onSticky, onUnSticky: onUnSticky };
    useEffect(function () {
        return registerStickyHeader({
            getElement: function () { return ref.current; },
            getTitle: function () { return propsRef.current.title; },
            isSticky: function () { return stickyRef.current; },
            setSticky: function (sticky) {
                stickyRef.current = sticky;
                setSticky(sticky);
            },
            onSticky: function (name) {
                var cb = propsRef.current.onSticky;
                if (cb) {
                    cb(name);
                }
            },
            onUnSticky: function (name) {
                var cb = propsRef.current.onUnSticky;
                if (cb) {
                    cb(name);
                }
            },
        });
    }, []);
    return (React.createElement("h2", { className: "category-name sticky__wrapper ".concat(isSticky ? 'is-sticky' : ''), ref: ref },
        showGoBack && (React.createElement("span", { className: "category-name__go-back", onClick: function () { return goBack && goBack(); } },
            React.createElement(FaChevronLeft, null))),
        React.createElement("span", { className: "category-name__text" }, title)));
};
export default StickyHeader;
//# sourceMappingURL=StickyHeader.js.map